import { useState } from "react";
import TabNav from "../../composants/TabNav/TabNav";
import './Mentions.css';
import CG from "../CG/CG";
import Securite from "../Securite/Securite";
import MentionsLegales from "../MentionsLegales/MentionsLegales";
import CharteRSE from "../CharteRSE/CharteRSE";
import CharteDeontologie from "../CharteDeontologie/CharteDeontologie";
import CharteAchatsDurables from "../CharteAchatsDurables/CharteAchatsDurables";

export default function MentionsPage() {
    const [activeTab, setActiveTab] = useState(0);

    // Définition des onglets
    const tabs = ["Conditions générales", "Politique de sécurité", "Mentions légales", "Charte RSE", "Charte achat durable", "Charte déontologie"];
    const inactiveTabs = [];

    return (
        <div className="mentions-container">
            <h1>Mentions</h1>

            <TabNav
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={(index) => setActiveTab(index)}
                inactiveTabs={inactiveTabs ?? []}
                inactiveTabsTooltips={inactiveTabs.reduce((acc, idx) => {
                    acc[tabs[idx]] = "Cette section n'est pas encore disponible";
                    return acc;
                }, {} as Record<string, string>)}
            />

            {/* Politique de sécurité */}
            {activeTab === 0 && (
                <div className="mentions-content fullpage">

                    <CG />
                </div>
            )}

            {/* Conditions générales */}
            {activeTab === 1 && (
                <div className="mentions-content fullpage">
                    <Securite />
                </div>
            )}


            {/* Mentions légales */}
            {activeTab === 2 && (
                <div className="mentions-content fullpage">
                    <MentionsLegales />
                </div>
            )}

            {/* Charte RSE */}
            {activeTab === 3 && (
                <div className="mentions-content fullpage">
                    <CharteRSE />
                </div>
            )}

            {/* Charte Achats Durables */}
            {activeTab === 4 && (
                <div className="mentions-content fullpage">
                    <CharteAchatsDurables />
                </div>
            )}

            {/* Charte déontologie */}
            {activeTab === 5 && (
                <div className="mentions-content fullpage">
                    <CharteDeontologie />
                </div>
            )}
        </div>
    );
}